import { useRequiredContext } from "@lib/utils";

import { PanelStack } from "../../shared/PanelStack/PanelStack";
import { HaNContext } from "../../shell/HaNContext";
import { HaNDetailsContext } from "../../shell/regions/HaNDetailsContext";
import { FacilityInfoPage } from "./FacilityInfoPage";

export const FacilityDetails = () => {
  const { selection } = useRequiredContext(HaNDetailsContext);

  if (selection.kind !== "facility") return null;

  return <FacilityDetailsContent facilityId={selection.id} />;
};

type FacilityDetailsContentProps = {
  facilityId: string;
};

// Looks the facility up among all of the building's facilities, so changing the filter doesn't close its details
const FacilityDetailsContent = ({ facilityId }: FacilityDetailsContentProps) => {
  const { filterData } = useRequiredContext(HaNContext);
  const facility = filterData.facilities.allData.find(f => f.id === facilityId);

  if (!facility) return null;

  return (
    <PanelStack initial="info">
      <PanelStack.Page pageId="info">
        <FacilityInfoPage facility={facility} />
      </PanelStack.Page>
    </PanelStack>
  );
};
